import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dialogTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: theme.spacing(1),
    gap: theme.spacing(1),
  },
  paragraph: {
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.secondary,
  },
  linkList: {
    marginBottom: theme.spacing(2),
  },
  bullet: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  link: {
    cursor: 'pointer',
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  radioLabel: {
    marginBottom: theme.spacing(0.5),
  },
}))

export default useStyles
